import React, { FC, useContext } from "react"

import { SubmittingContext } from "@/onboarding/features/product/helpers"
import LoadingSpinner from "@/components/LoadingSpinner"

const SubmittingSpinner: FC = () => {
  const [submitting] = useContext(SubmittingContext)

  return submitting && <LoadingSpinner />
}

export default SubmittingSpinner
